import { maintenance } from '../../../../../maintenance';
import type { Asset, Device } from '../../../../api/assetAdministrationBackendCodec.ts';
import { useState } from 'react';
import { useAppDispatch } from '../../../../../configuration/setup/hooks.ts';
import { useDisassociateDeviceFromAssetMutation } from '../../../../../services/assetsApi.ts';
import { sleep } from '../../../../../utils.ts';
import { assetModified } from '../assetSidebarSlice.ts';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { DisassociateDeviceDialog } from '../../dialogs/DisassociateDeviceDialog.tsx';

export const DisasociateDevice = ({ asset, device }: { asset: Asset; device: Device }) => {
    const [showDialog, setShowDialog] = useState(false);
    const dispatch = useAppDispatch();
    const [disassociateDeviceFromAsset] = useDisassociateDeviceFromAssetMutation();

    const handleDisassociateDeviceConfirm = (assetId: string, deviceId: string, reason: string) => {
        disassociateDeviceFromAsset({ assetId, deviceId, reason })
            .unwrap()
            .then(() => sleep(500))
            .then(() => dispatch(assetModified()))
            .catch(error => {
                console.error(`Could not disassociate asset: ${error}`);
                Notification.error('Could not disassociate asset');
            });
        setShowDialog(false);
    };

    return (
        <>
            <button
                disabled={maintenance.enabled}
                type='button'
                className='btn btn-warning btn-outline'
                onClick={() => setShowDialog(true)}
                data-cy='disassociate-device-button'
            >
                Disassociate Device
            </button>
            <DisassociateDeviceDialog
                showDialog={showDialog}
                setShowDialog={setShowDialog}
                asset={{
                    id: asset.id,
                    accountId: asset.account_id,
                    vin: asset.identification,
                    status: asset.status,
                }}
                handleConfirm={handleDisassociateDeviceConfirm}
                device={device}
            />
        </>
    );
};
